import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            <div>
              <Link to="/" className="text-xl font-heading font-bold whitespace-nowrap cursor-pointer">
                {siteInfo.name}
              </Link>
              <p className="mt-4 text-sm text-background-300 leading-relaxed">
                {siteInfo.tagline}
              </p>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                每日更新推荐，帮助创作者与读者高效发现热门同人内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">
                <a href="#footer-categories" className="cursor-pointer">作品分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">
                <a href="#footer-links" className="cursor-pointer">快速链接</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
                </li>
                <li>
                  <Link to="/category/novel" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">同人小说</Link>
                </li>
                <li>
                  <Link to="/category/comic" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">同人漫画</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">
                <a href="#footer-contact" className="cursor-pointer">联系方式</a>
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-base w-4 flex items-center justify-center"></i>
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line text-base w-4 flex items-center justify-center"></i>
                  <span>{siteInfo.address}</span>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-5">
                <a
                  href={siteInfo.social.weibo}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a
                  href={siteInfo.social.bilibili}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  aria-label="哔哩哔哩"
                >
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
                <a
                  href={siteInfo.social.lofter}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  aria-label="Lofter"
                >
                  <i className="ri-link text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-sm text-background-500">
                &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
              </p>
              <p className="text-xs text-background-600">
                本站内容来源于网络，仅供同人爱好者交流学习，如有侵权请联系删除
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}